import { map, Observable } from 'rxjs';
import { CompanyModel as U2ApiCompanyModel, UserRoleCompany } from '../services/u2api.services';
import { AuditUserCommand, CompanyModel as UsersApiCompanyModel } from '../services/usersapi/usersapi.services';
import { CompanyDto } from '../services/rolesapi/rolesapi.services';
import { IamWrapperConstants } from '../iamWrapperConstants';

export class AddLatestAccessedCompanyTransform {
  static transformOutput(response$: Observable<void>, userCompanies: CompanyDto[]): Observable<U2ApiCompanyModel[]> {
    return response$.pipe(
      map(response =>
        userCompanies.slice(0, IamWrapperConstants.CompaniesPageSize).map(
          company =>
            new U2ApiCompanyModel({
              companyId: company.companyId,
              companyName: company.companyName,
            }),
        ),
      ),
    );
  }
  static transformInput(userRoleCompany: UserRoleCompany, userObjectId: string, userCompanies: UsersApiCompanyModel[]): AuditUserCommand {
    const companyCode = userCompanies.find(company => company.companyId === userRoleCompany.companyId).name;
    return new AuditUserCommand({
      userObjectId,
      companyCode,
    });
  }
}
